module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Backspace-fd2e33388846b6eb8101e7c78a574d99.svg";